
import { defineComponent, computed } from 'vue'
import SkeletonItem from '@/components/skeleton-item'
import { useThrottleRender } from '@/components/hooks'

export default defineComponent({
  name: 'MsSkeleton',
  components: {
    [SkeletonItem.name]: SkeletonItem
  },
  props: {
    animated: {
      type: Boolean,
      default: true
    },
    count: {
      type: Number,
      default: 1
    },
    rows: {
      type: Number,
      default: 3
    },
    loading: {
      type: Boolean,
      default: true
    },
    throttle: {
      type: Number,
      default: undefined
    }
  },
  setup (props) {
    const innerLoading = computed(() => {
      return props.loading
    })

    const uiLoading = useThrottleRender(innerLoading, props.throttle)

    return {
      uiLoading
    }
  }
})
